import actions from './actions';

const {
  GET_ALL_CUSTOMERS_BEGIN,
  GET_ALL_CUSTOMERS_SUCCESS,
  GET_ALL_CUSTOMERS_ERR,

  GET_SINGLE_CUSTOMER_BEGIN,
  GET_SINGLE_CUSTOMER_SUCCESS,
  GET_SINGLE_CUSTOMER_ERR,

  SET_CUSTOMER_FORM_DATA,
} = actions;

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const singleCustomerInitialState = {
  data: {},
  formData: {},
  loading: false,
  error: null,
};

const customersReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_ALL_CUSTOMERS_BEGIN:
      return {
        ...initialState,
        loading: true,
      };
    case GET_ALL_CUSTOMERS_SUCCESS:
      return {
        ...initialState,
        data,
        loading: false,
      };
    case GET_ALL_CUSTOMERS_ERR:
      return {
        ...initialState,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const singleCustomerReducer = (state = singleCustomerInitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_SINGLE_CUSTOMER_BEGIN:
      return {
        ...initialState,
        loading: true,
      };
    case GET_SINGLE_CUSTOMER_SUCCESS:
      return {
        ...initialState,
        data,
        loading: false,
      };
    case GET_SINGLE_CUSTOMER_ERR:
      return {
        ...initialState,
        error: err,
        loading: false,
      };
    case SET_CUSTOMER_FORM_DATA:
      return {
        ...initialState,
        formData: data,
      };
    default:
      return state;
  }
};

export { customersReducer, singleCustomerReducer };
